'use client';

import { useQuery } from '@tanstack/react-query';
import { curatorQueries } from '../../query-factory';
import {
  mapProposalDetailToView,
  mapRecruitmentDetailToView,
} from '../components/seedingDetail/adapters';
import type { SeedingCampaignDetail } from '../components/seedingDetail/types';

/**
 * 통일 시딩 상세 — campaignId 만으로 모집/제안 상세를 조회하고, `kind` 로 분기해
 * presentation `SeedingCampaignDetail` 로 매핑한다 (참여-후 단일 라우트 `/campaign/seeding/[campaignId]`용).
 *
 * 모집 신청 전(`BEFORE_APPLY`, participation==null)은 별도 신청 라우트가 담당하므로 본 hook 진입 대상 아님.
 */
export const useSeedingDetail = (campaignId: number | undefined) =>
  useQuery({
    ...curatorQueries.campaigns.seedingCampaignDetail({ campaignId: campaignId! }),
    enabled: campaignId !== undefined && campaignId > 0,
    select: (data): SeedingCampaignDetail =>
      data.kind === 'recruit' ? mapRecruitmentDetailToView(data) : mapProposalDetailToView(data),
  });
